import { PermissionType } from 'api/types/entity';
import { ROUTES } from 'libs/navigation';
import { usePermissions } from 'libs/permissions';
// eslint-disable-next-line no-restricted-imports
import { Navigate } from 'react-router-dom';

export const AdministrationRoute = () => {
  const { checkPermissions } = usePermissions();

  if (checkPermissions([PermissionType.SystemSetting_GetOne])) {
    return (
      <Navigate replace to={ROUTES.administration.accountingSystem.fullPath} />
    );
  }

  if (checkPermissions([PermissionType.User_GetList])) {
    return <Navigate replace to={ROUTES.administration.admins.fullPath} />;
  }

  return <Navigate replace to={ROUTES.fullPath} />;
};
